import api, { buildQueryString } from './api';
import type {
  VisitAssignment,
  VisitStatus,
  PaginatedResponse,
  ApiResponse,
  PaginationParams,
  CreateVisitForm,
} from '../types';

export interface VisitFilters extends PaginationParams {
  employeeId?: string;
  customerId?: string;
  status?: VisitStatus;
  date?: string;
  startDate?: string;
  endDate?: string;
  priority?: string;
}

export const visitService = {
  async getAll(params?: VisitFilters): Promise<PaginatedResponse<VisitAssignment>> {
    const qs = buildQueryString(params as Record<string, unknown>);
    const response = await api.get<PaginatedResponse<VisitAssignment>>(`/api/visits${qs}`);
    return response.data;
  },

  async getById(id: string): Promise<VisitAssignment> {
    const response = await api.get<ApiResponse<VisitAssignment>>(`/api/visits/${id}`);
    return response.data.data;
  },

  async create(data: CreateVisitForm): Promise<VisitAssignment> {
    const response = await api.post<ApiResponse<VisitAssignment>>('/api/visits', data);
    return response.data.data;
  },

  async update(id: string, data: Partial<CreateVisitForm>): Promise<VisitAssignment> {
    const response = await api.patch<ApiResponse<VisitAssignment>>(`/api/visits/${id}`, data);
    return response.data.data;
  },

  async updateStatus(id: string, status: VisitStatus, notes?: string): Promise<VisitAssignment> {
    const response = await api.patch<ApiResponse<VisitAssignment>>(`/api/visits/${id}/status`, { status, notes });
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/visits/${id}`);
  },

  async bulkCreate(visits: CreateVisitForm[]): Promise<VisitAssignment[]> {
    const response = await api.post<ApiResponse<VisitAssignment[]>>('/api/visits/bulk', { visits });
    return response.data.data;
  },

  async getMyVisits(params?: VisitFilters): Promise<PaginatedResponse<VisitAssignment>> {
    const qs = buildQueryString(params as Record<string, unknown>);
    const response = await api.get<PaginatedResponse<VisitAssignment>>(`/api/visits/my-visits${qs}`);
    return response.data;
  },

  async getTeamVisits(params?: VisitFilters): Promise<PaginatedResponse<VisitAssignment>> {
    const qs = buildQueryString(params as Record<string, unknown>);
    const response = await api.get<PaginatedResponse<VisitAssignment>>(`/api/visits/team${qs}`);
    return response.data;
  },
};
